import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** 表示するコンポーネントの種類 */
  type?: 'note';
  /** 表示する文字列のリスト */
  notes: string[];
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * 備考のコンポーネント
 */
export const Notes: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type = 'note',
  notes,
  className,
  'data-test': dataTest,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _clsName = className || type;
  const _notes = notes[0].includes('\n')
    ? notes[0].split('\n').map((n, index) => (
        <Note key={`${dataTest}-${index}`} data-test={`${dataTest}-${index}`}>
          {n}
          <br />
        </Note>
      ))
    : notes.map((n, index) => (
        <Note key={`${dataTest}-${index}`} data-test={`${dataTest}-${index}`}>
          {n}
        </Note>
      ));
  return (
    <Element {...props} className={_clsName} data-test={dataTest}>
      {_notes}
      {props.children}
    </Element>
  );
};
Notes.displayName = 'Notes';

const Note: WrappedFC<typeof DEFAULT_COMPONENT, Record<string, unknown>> = ({
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  return <Element {...props}>{props.children}</Element>;
};
